import Image from '@/src/shared/components/Image';
import styles from './VuSocialLogo.module.scss';
import { clsx } from 'clsx';
import blueLogo from '@/public/next-public/images/logo/logo.svg';
import whiteLogo from '@/public/next-public/images/logo/logo-white.svg';
import { websiteBaseUrl } from '@/core/routes';

type Props = {
  className?: string;
  color?: 'white' | 'brand';
  redirectToHomepageOnClick?: boolean;
};

export default function VuSocialLogo({
  color = 'brand',
  className,
  redirectToHomepageOnClick = true,
}: Props) {
  const logo = (
    <Image
      alt="VuSocial logo"
      src={color === 'white' ? whiteLogo : blueLogo}
      fill
    />
  );
  if (redirectToHomepageOnClick) {
    return (
      <a
        className={clsx(styles.roomvuLogo, styles.clickable, className)}
        href={websiteBaseUrl}
      >
        {logo}
      </a>
    );
  }
  return <span className={clsx(styles.roomvuLogo, className)}>{logo}</span>;
}
